import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "audited_changes": {
      "column": {
        "default": null,
        "name": "audited_changes",
        "null": true,
        "type": "text"
      },
      "name": "audited_changes",
      "selected_by_default": null,
      "translated": null
    },
    "auditable": {
      "column": null,
      "name": "auditable",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "current_school_id": {
      "column": {
        "default": null,
        "name": "current_school_id",
        "null": true,
        "type": null
      },
      "name": "current_school_id",
      "selected_by_default": null,
      "translated": null
    },
    "current_school_class_id": {
      "column": {
        "default": null,
        "name": "current_school_class_id",
        "null": true,
        "type": null
      },
      "name": "current_school_class_id",
      "selected_by_default": null,
      "translated": null
    },
    "current_user_id": {
      "column": {
        "default": null,
        "name": "current_user_id",
        "null": true,
        "type": null
      },
      "name": "current_user_id",
      "selected_by_default": null,
      "translated": null
    },
    "extra_liquid_variables": {
      "column": {
        "default": null,
        "name": "extra_liquid_variables",
        "null": true,
        "type": "text"
      },
      "name": "extra_liquid_variables",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "params": {
      "column": {
        "default": null,
        "name": "params",
        "null": true,
        "type": "text"
      },
      "name": "params",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "contact_point_id": {
      "column": {
        "default": null,
        "name": "contact_point_id",
        "null": false,
        "type": null
      },
      "name": "contact_point_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactPoint::Audit",
  "collectionKey": "contact_point/audits",
  "collectionName": "contact_point_audits",
  "i18nKey": "contact_point/audit",
  "camelizedLower": "contactPoint::Audit",
  "name": "ContactPointAudit",
  "nameDasherized": "contact-point-audit",
  "pluralName": "contact_point_audits",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::AuditAction",
      "collectionName": "audit_actions",
      "foreignKey": "audit_action_id",
      "name": "audit_action",
      "macro": "belongs_to",
      "resource_name": "AuditAction",
      "through": null
    },
    {
      "className": "ContactPoint",
      "collectionName": "contact_points",
      "foreignKey": "contact_point_id",
      "name": "auditable",
      "macro": "belongs_to",
      "resource_name": "ContactPoint",
      "through": null
    },
    {
      "className": "ContactPoint",
      "collectionName": "contact_points",
      "foreignKey": "contact_point_id",
      "name": "contact_point",
      "macro": "belongs_to",
      "resource_name": "ContactPoint",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "current_school_id",
      "name": "current_school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "current_school_class_id",
      "name": "current_school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "current_user_id",
      "name": "current_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "audit_action_id",
      "column": {
        "default": null,
        "name": "audit_action_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "audited_changes",
      "column": {
        "default": null,
        "name": "audited_changes",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "contact_point_id",
      "column": {
        "default": null,
        "name": "contact_point_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "current_school_class_id",
      "column": {
        "default": null,
        "name": "current_school_class_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "current_school_id",
      "column": {
        "default": null,
        "name": "current_school_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "current_user_id",
      "column": {
        "default": null,
        "name": "current_user_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "extra_liquid_variables",
      "column": {
        "default": null,
        "name": "extra_liquid_variables",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "params",
      "column": {
        "default": null,
        "name": "params",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ActiveRecordAuditable::AuditAction",
      "collectionName": "audit_actions",
      "foreignKey": "audit_action_id",
      "name": "audit_action",
      "macro": "belongs_to",
      "resource_name": "AuditAction",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "current_school_id",
      "name": "current_school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "current_school_class_id",
      "name": "current_school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "current_user_id",
      "name": "current_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "ContactPoint",
      "collectionName": "contact_points",
      "foreignKey": "contact_point_id",
      "name": "contact_point",
      "macro": "belongs_to",
      "resource_name": "ContactPoint",
      "through": null
    }
  ],
  "paramKey": "contact_point_audit",
  "primaryKey": "id"
}

/** Frontend model for ContactPointAudit. */
class ContactPointAudit extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  auditedChanges() {
    return this.readAttributeUnderscore("audited_changes")
  }

  /** @returns {boolean} */
  hasAuditedChanges() {
    const value = this.auditedChanges()

    return this._isPresent(value)
  }

  /** @returns {any} */
  auditable() {
    return this.readAttributeUnderscore("auditable")
  }

  /** @returns {boolean} */
  hasAuditable() {
    const value = this.auditable()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentSchoolId() {
    return this.readAttributeUnderscore("current_school_id")
  }

  /** @returns {boolean} */
  hasCurrentSchoolId() {
    const value = this.currentSchoolId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentSchoolClassId() {
    return this.readAttributeUnderscore("current_school_class_id")
  }

  /** @returns {boolean} */
  hasCurrentSchoolClassId() {
    const value = this.currentSchoolClassId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  currentUserId() {
    return this.readAttributeUnderscore("current_user_id")
  }

  /** @returns {boolean} */
  hasCurrentUserId() {
    const value = this.currentUserId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  extraLiquidVariables() {
    return this.readAttributeUnderscore("extra_liquid_variables")
  }

  /** @returns {boolean} */
  hasExtraLiquidVariables() {
    const value = this.extraLiquidVariables()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  params() {
    return this.readAttributeUnderscore("params")
  }

  /** @returns {boolean} */
  hasParams() {
    const value = this.params()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  contactPointId() {
    return this.readAttributeUnderscore("contact_point_id")
  }

  /** @returns {boolean} */
  hasContactPointId() {
    const value = this.contactPointId()

    return this._isPresent(value)
  }

  /** @returns {import("./audit-action.js").default | null} */
  auditAction() {
    return this._readBelongsToReflection({reflectionName: "audit_action"})
  }

  /** @returns {Promise<import("./audit-action.js").default | null>} */
  loadAuditAction() {
    if (!("auditActionId" in this)) throw new Error("Foreign key method wasn't defined: auditActionId")

    const id = this.auditActionId()
    const modelClass = modelClassRequire("AuditAction")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "audit_action", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./school.js").default | null} */
  currentSchool() {
    return this._readBelongsToReflection({reflectionName: "current_school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadCurrentSchool() {
    if (!("currentSchoolId" in this)) throw new Error("Foreign key method wasn't defined: currentSchoolId")

    const id = this.currentSchoolId()
    const modelClass = modelClassRequire("School")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "current_school", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./school-class.js").default | null} */
  currentSchoolClass() {
    return this._readBelongsToReflection({reflectionName: "current_school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadCurrentSchoolClass() {
    if (!("currentSchoolClassId" in this)) throw new Error("Foreign key method wasn't defined: currentSchoolClassId")

    const id = this.currentSchoolClassId()
    const modelClass = modelClassRequire("SchoolClass")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "current_school_class", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./user.js").default | null} */
  currentUser() {
    return this._readBelongsToReflection({reflectionName: "current_user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadCurrentUser() {
    if (!("currentUserId" in this)) throw new Error("Foreign key method wasn't defined: currentUserId")

    const id = this.currentUserId()
    const modelClass = modelClassRequire("User")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "current_user", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./contact-point.js").default | null} */
  contactPoint() {
    return this._readBelongsToReflection({reflectionName: "contact_point"})
  }

  /** @returns {Promise<import("./contact-point.js").default | null>} */
  loadContactPoint() {
    if (!("contactPointId" in this)) throw new Error("Foreign key method wasn't defined: contactPointId")

    const id = this.contactPointId()
    const modelClass = modelClassRequire("ContactPoint")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "contact_point", model: this, modelClass},
      {ransack}
    )
  }
}

export default ContactPointAudit
